/*a-single-shared-cache*/
/*vercel*/
/*for-local-development*/
/*remote-caching-on-vercel*/
/*artifact-integrity-and-authenticity-verification*/
/*remote-cache-api*/
/*managed-remote-cache-with-vercel*/
/*self-hosting*/
/*openapi-specification*/
/*community-implementations*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "远程缓存",
  "description": "跨机器共享缓存工件，加快构建速度。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 的 任务缓存 通过避免重复执行相同的工作来节省时间。"
  }, {
    "heading": "",
    "content": "¥Turborepo's task cache saves time by never doing the same work twice."
  }, {
    "heading": "",
    "content": "但有一个问题：缓存位于你的计算机本地。当你使用持续集成系统时，这可能会导致大量重复工作："
  }, {
    "heading": "",
    "content": "¥But there's a problem: the cache is local to your machine. When you're working with a Continuous Integration system, this can result in a lot of duplicated work:"
  }, {
    "heading": "",
    "content": "由于 Turborepo 默认仅缓存到本地文件系统，因此即使所有任务输入都相同，也必须在每台机器上（由你、你的团队成员、你的 CI、你的 PaaS 等）重新执行相同的任务 (turbo run build) - 这会浪费时间和资源。"
  }, {
    "heading": "",
    "content": "¥Since Turborepo only caches to the local filesystem by default, the same task (turbo run build) must be re-executed on each machine (by you, by your teammates, by your CI, by your PaaS, etc.) even when all of the task inputs are identical — which wastes time and resources."
  }, {
    "heading": "",
    "content": "使用 Turborepo 无需使用远程缓存。虽然远程缓存将带来最显著的加速，但你也可以在没有远程缓存的情况下加快现有工作流程的速度。"
  }, {
    "heading": "",
    "content": "¥You don't have to use Remote Caching to use Turborepo. While Remote Caching\nwill bring the most significant speedups, you can make your existing workflows\nfaster without Remote Caching, too."
  }, {
    "heading": "单一共享缓存-a-single-shared-cache",
    "content": "¥A single, shared cache"
  }, {
    "heading": "单一共享缓存-a-single-shared-cache",
    "content": "如果你可以在整个团队（甚至你的持续集成 (CI)）之间共享一个 Turborepo 缓存会怎么样？"
  }, {
    "heading": "单一共享缓存-a-single-shared-cache",
    "content": "¥What if you could share a single Turborepo cache across your entire team (and even your CI)?"
  }, {
    "heading": "单一共享缓存-a-single-shared-cache",
    "content": "Turborepo 可以与远程缓存进行安全通信 - 一个云服务器，用于存储你的任务结果。这可以避免整个组织中的重复工作，从而节省大量时间。"
  }, {
    "heading": "单一共享缓存-a-single-shared-cache",
    "content": "¥Turborepo can securely communicate with a remote cache - a cloud server that stores the results of your tasks. This can save enormous amounts of time by preventing duplicated work across your entire organization."
  }, {
    "heading": "单一共享缓存-a-single-shared-cache",
    "content": "远程缓存是免费的，可以与 托管提供程序 一起使用，也可以作为 自托管缓存 使用。"
  }, {
    "heading": "单一共享缓存-a-single-shared-cache",
    "content": "¥Remote Caching is free and can be used with both managed providers or as a self-hosted cache."
  }, {
    "heading": "单一共享缓存-a-single-shared-cache",
    "content": "远程缓存是 Turborepo 的一项强大功能，但功能强大，责任重大。首先确保缓存正确，并仔细检查 环境处理变量。另请记住，Turborepo 将日志视为工件，因此请注意打印到控制台的内容。"
  }, {
    "heading": "单一共享缓存-a-single-shared-cache",
    "content": "¥Remote Caching is a powerful feature of Turborepo, but, with great power,\ncomes great responsibility. Make sure you are caching correctly first and\ndouble check handling of environment\nvariables. Please\nalso remember Turborepo treats logs as artifacts, so be aware of what you are\nprinting to the console."
  }, {
    "heading": "vercel-vercel",
    "content": "即使你的应用不在 Vercel 上托管，Vercel 远程缓存 在所有计划中均可免费使用。按照以下步骤为你的仓库启用远程缓存。"
  }, {
    "heading": "vercel-vercel",
    "content": "¥Vercel Remote Cache is free to use on all plans, even if you do not host your applications on Vercel. Follow the steps below to enable Remote Caching for your repository."
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "¥For Local Development"
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "要将本地 Turborepo 链接到远程缓存，请使用你的 Vercel 账户验证 Turborepo CLI："
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "¥To link your local Turborepo to your Remote Cache, authenticate the Turborepo CLI with your Vercel account:"
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "如果你尚未安装 全局 turbo，也可以使用包管理器："
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "¥You can also use your package manager if you do not have global turbo installed:"
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "如果你的远程缓存配置为使用单点登录，则需要运行 npx turbo login --sso-team=team-name 才能获取具有正确权限的缓存令牌。"
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "¥If your Remote Cache is configured to use single-sign-on you will need to run\nnpx turbo login --sso-team=team-name in order to get a cache token with the\ncorrect privileges."
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "现在，将你的 Turborepo 链接到你的远程缓存："
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "¥Now, link your Turborepo to your Remote Cache:"
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "启用后，对当前缓存的包进行一些更改，并使用 turbo run 针对其运行任务。你的缓存工件现在将存储在本地和远程缓存中。"
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "¥Once enabled, make some changes to a package you are currently caching and run tasks against it with turbo run.\nYour cache artifacts will now be stored locally and in your Remote Cache."
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "要验证，请使用以下命令删除本地 Turborepo 缓存："
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "¥To verify, delete your local Turborepo cache with:"
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "然后，再次运行相同的构建。如果一切正常，turbo 不应在本地执行任务。相反，它会从你的远程缓存下载日志和工件，并将它们重放给你。"
  }, {
    "heading": "用于本地开发-for-local-development",
    "content": "¥Then, run the same build again. If things are working properly, turbo should not execute tasks locally. Instead, it will download the logs and artifacts from your Remote Cache and replay them back to you."
  }, {
    "heading": "vercel-上的远程缓存-remote-caching-on-vercel",
    "content": "¥Remote Caching on Vercel"
  }, {
    "heading": "vercel-上的远程缓存-remote-caching-on-vercel",
    "content": "如果你在 Vercel 上构建和托管应用，则一旦你使用 turbo，远程缓存将自动为你设置。更多信息请参阅 Vercel 文档。"
  }, {
    "heading": "vercel-上的远程缓存-remote-caching-on-vercel",
    "content": "¥If you are building and hosting your apps on Vercel, Remote Caching will be automatically set up on your behalf once you use turbo. Refer to the Vercel documentation for more information."
  }, {
    "heading": "工件完整性和真实性验证-artifact-integrity-and-authenticity-verification",
    "content": "¥Artifact Integrity and Authenticity Verification"
  }, {
    "heading": "工件完整性和真实性验证-artifact-integrity-and-authenticity-verification",
    "content": "Turborepo 可以在将工件上传到远程缓存之前使用密钥对其进行签名。Turborepo 使用你提供的密钥对工件进行 HMAC-SHA256 签名。Turborepo 将验证已下载的远程缓存工件。任何验证失败的工件都将被 Turborepo 忽略并视为缓存未命中。"
  }, {
    "heading": "工件完整性和真实性验证-artifact-integrity-and-authenticity-verification",
    "content": "¥Turborepo can sign artifacts with a secret key before uploading them to the Remote Cache. Turborepo uses HMAC-SHA256 signatures on artifacts using a secret key you provide.\nTurborepo will verify the Remote Cache artifacts' integrity and authenticity when they're downloaded.\nAny artifacts that fail to verify will be ignored and treated as a cache miss by Turborepo."
  }, {
    "heading": "工件完整性和真实性验证-artifact-integrity-and-authenticity-verification",
    "content": "要启用此功能，请在 turbo.json 配置中将 remoteCache 选项设置为包含 signature: true。然后通过声明 TURBO_REMOTE_CACHE_SIGNATURE_KEY 环境变量来指定你的密钥。"
  }, {
    "heading": "工件完整性和真实性验证-artifact-integrity-and-authenticity-verification",
    "content": "¥To enable this feature, set the remoteCache options on your turbo.json config to include signature: true. Then specify your secret key by declaring the TURBO_REMOTE_CACHE_SIGNATURE_KEY environment variable."
  }, {
    "heading": "远程缓存-api-remote-cache-api",
    "content": "¥Remote Cache API"
  }, {
    "heading": "远程缓存-api-remote-cache-api",
    "content": "任何符合 Turborepo 远程缓存 API 规范的 HTTP 服务器都可以实现远程缓存。"
  }, {
    "heading": "远程缓存-api-remote-cache-api",
    "content": "¥A Remote Cache can be implemented by any HTTP server that meets Turborepo's Remote Caching API specification."
  }, {
    "heading": "使用-vercel-管理远程缓存-managed-remote-cache-with-vercel",
    "content": "¥Managed Remote Cache with Vercel"
  }, {
    "heading": "使用-vercel-管理远程缓存-managed-remote-cache-with-vercel",
    "content": "Vercel，Turborepo 的创建者和维护者，提供与 Turborepo 完全兼容的托管远程缓存。"
  }, {
    "heading": "使用-vercel-管理远程缓存-managed-remote-cache-with-vercel",
    "content": "¥Vercel, the creators and maintainers of Turborepo, provide a managed Remote Cache that is fully compatible with Turborepo."
  }, {
    "heading": "使用-vercel-管理远程缓存-managed-remote-cache-with-vercel",
    "content": "使用 Vercel 远程缓存 无需配置，并通过开源 Vercel 远程缓存 SDK 自动与 Vercel 部署 集成。"
  }, {
    "heading": "使用-vercel-管理远程缓存-managed-remote-cache-with-vercel",
    "content": "¥Using Vercel Remote Cache is zero-configuration and automatically integrates with Vercel deployments through the open-source Vercel Remote Cache SDK."
  }, {
    "heading": "使用-vercel-管理远程缓存-managed-remote-cache-with-vercel",
    "content": "了解有关 Vercel 上的 Turborepo 或 免费部署模板 的更多信息以试用。"
  }, {
    "heading": "使用-vercel-管理远程缓存-managed-remote-cache-with-vercel",
    "content": "¥Learn more about Turborepo on Vercel or deploy a template for free to try it out."
  }, {
    "heading": "自托管-self-hosting",
    "content": "¥Self-hosting"
  }, {
    "heading": "自托管-self-hosting",
    "content": "你还可以自行托管自己的远程缓存，并使用 --manual 标志登录，提供 API URL、团队和令牌信息。"
  }, {
    "heading": "自托管-self-hosting",
    "content": "¥You can also self-host your own Remote Cache and log into it using the --manual flag to provide API URL, team, and token information."
  }, {
    "heading": "openapi-规范-openapi-specification",
    "content": "¥OpenAPI specification"
  }, {
    "heading": "openapi-规范-openapi-specification",
    "content": "易于阅读的查看器"
  }, {
    "heading": "openapi-规范-openapi-specification",
    "content": "¥Human-readable viewer"
  }, {
    "heading": "openapi-规范-openapi-specification",
    "content": "JSON"
  }, {
    "heading": "openapi-规范-openapi-specification",
    "content": "目前，所有版本的 turbo 都与 v8 端点兼容。"
  }, {
    "heading": "openapi-规范-openapi-specification",
    "content": "¥At this time, all versions of turbo are compatible with the v8 endpoints."
  }, {
    "heading": "社区实现-community-implementations",
    "content": "¥Community implementations"
  }, {
    "heading": "社区实现-community-implementations",
    "content": "Turborepo 社区已经创建了远程缓存的开源实现。"
  }, {
    "heading": "社区实现-community-implementations",
    "content": "¥The Turborepo community has created open-source implementations of the Remote Cache."
  }, {
    "heading": "社区实现-community-implementations",
    "content": "brunojppb/turbo-cache-server"
  }, {
    "heading": "社区实现-community-implementations",
    "content": "ducktors/turborepo-remote-cache"
  }, {
    "heading": "社区实现-community-implementations",
    "content": "Tapico/tapico-turborepo-remote-cache"
  }],
  "headings": [{
    "id": "单一共享缓存-a-single-shared-cache",
    "content": "单一共享缓存 /*a-single-shared-cache*/"
  }, {
    "id": "vercel-vercel",
    "content": "Vercel /*vercel*/"
  }, {
    "id": "用于本地开发-for-local-development",
    "content": "用于本地开发 /*for-local-development*/"
  }, {
    "id": "vercel-上的远程缓存-remote-caching-on-vercel",
    "content": "Vercel 上的远程缓存 /*remote-caching-on-vercel*/"
  }, {
    "id": "工件完整性和真实性验证-artifact-integrity-and-authenticity-verification",
    "content": "工件完整性和真实性验证 /*artifact-integrity-and-authenticity-verification*/"
  }, {
    "id": "远程缓存-api-remote-cache-api",
    "content": "远程缓存 API /*remote-cache-api*/"
  }, {
    "id": "使用-vercel-管理远程缓存-managed-remote-cache-with-vercel",
    "content": "使用 Vercel 管理远程缓存 /*managed-remote-cache-with-vercel*/"
  }, {
    "id": "自托管-self-hosting",
    "content": "自托管 /*self-hosting*/"
  }, {
    "id": "openapi-规范-openapi-specification",
    "content": "OpenAPI 规范 /*openapi-specification*/"
  }, {
    "id": "社区实现-community-implementations",
    "content": "社区实现 /*community-implementations*/"
  }]
};
import {Callout} from '#components/callout';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {ThemeAwareImage} from '#components/theme-aware-image';
export const toc = [{
  depth: 2,
  url: "#单一共享缓存-a-single-shared-cache",
  title: _jsx(_Fragment, {
    children: "单一共享缓存 "
  })
}, {
  depth: 2,
  url: "#vercel-vercel",
  title: _jsx(_Fragment, {
    children: "Vercel "
  })
}, {
  depth: 3,
  url: "#用于本地开发-for-local-development",
  title: _jsx(_Fragment, {
    children: "用于本地开发 "
  })
}, {
  depth: 3,
  url: "#vercel-上的远程缓存-remote-caching-on-vercel",
  title: _jsx(_Fragment, {
    children: "Vercel 上的远程缓存 "
  })
}, {
  depth: 3,
  url: "#工件完整性和真实性验证-artifact-integrity-and-authenticity-verification",
  title: _jsx(_Fragment, {
    children: "工件完整性和真实性验证 "
  })
}, {
  depth: 2,
  url: "#远程缓存-api-remote-cache-api",
  title: _jsx(_Fragment, {
    children: "远程缓存 API "
  })
}, {
  depth: 3,
  url: "#使用-vercel-管理远程缓存-managed-remote-cache-with-vercel",
  title: _jsx(_Fragment, {
    children: "使用 Vercel 管理远程缓存 "
  })
}, {
  depth: 3,
  url: "#自托管-self-hosting",
  title: _jsx(_Fragment, {
    children: "自托管 "
  })
}, {
  depth: 4,
  url: "#openapi-规范-openapi-specification",
  title: _jsx(_Fragment, {
    children: "OpenAPI 规范 "
  })
}, {
  depth: 4,
  url: "#社区实现-community-implementations",
  title: _jsx(_Fragment, {
    children: "社区实现 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo 的 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "任务缓存"
      }), " 通过避免重复执行相同的工作来节省时间。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo's ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "task cache"
      }), " saves time by never doing the same work twice."]
    }), "\n", _jsx(_components.p, {
      children: "但有一个问题：缓存位于你的计算机本地。当你使用持续集成系统时，这可能会导致大量重复工作："
    }), "\n", _jsxs(_components.p, {
      children: ["¥But there's a problem: ", _jsx(_components.strong, {
        children: "the cache is local to your machine"
      }), ". When you're working with a Continuous Integration system, this can result in a lot of duplicated work:"]
    }), "\n", _jsx(ThemeAwareImage, {
      dark: {
        alt: 'Local caching creates a cache on each system.',
        src: '/images/docs/local-caching-dark.png',
        props: {
          width: 896,
          height: 345
        }
      },
      light: {
        alt: 'Local caching creates a cache on each system.',
        src: '/images/docs/local-caching-light.png',
        props: {
          width: 896,
          height: 345
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: ["由于 Turborepo 默认仅缓存到本地文件系统，因此即使所有任务输入都相同，也必须在每台机器上（由你、你的团队成员、你的 CI、你的 PaaS 等）重新执行相同的任务 (", _jsx(_components.code, {
        children: "turbo run build"
      }), ") - 这会浪费时间和资源。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Since Turborepo only caches to the local filesystem by default, the same task (", _jsx(_components.code, {
        children: "turbo run build"
      }), ") must be ", _jsx(_components.strong, {
        children: "re-executed on each machine"
      }), " (by you, by your teammates, by your CI, by your PaaS, etc.) even when all of the task inputs are identical — which ", _jsx(_components.strong, {
        children: "wastes time and resources"
      }), "."]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsx(_components.p, {
        children: "使用 Turborepo 无需使用远程缓存。虽然远程缓存将带来最显著的加速，但你也可以在没有远程缓存的情况下加快现有工作流程的速度。"
      }), _jsx(_components.p, {
        children: "¥You don't have to use Remote Caching to use Turborepo. While Remote Caching\nwill bring the most significant speedups, you can make your existing workflows\nfaster without Remote Caching, too."
      })]
    }), "\n", _jsx(_components.h2, {
      id: "单一共享缓存-a-single-shared-cache",
      children: "单一共享缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥A single, shared cache"
    }), "\n", _jsx(_components.p, {
      children: "如果你可以在整个团队（甚至你的持续集成 (CI)）之间共享一个 Turborepo 缓存会怎么样？"
    }), "\n", _jsx(_components.p, {
      children: "¥What if you could share a single Turborepo cache across your entire team (and even your CI)?"
    }), "\n", _jsx(ThemeAwareImage, {
      dark: {
        alt: 'Remote caching creates a shared cache for your entire team.',
        src: '/images/docs/remote-caching-dark.png',
        props: {
          width: 896,
          height: 489
        }
      },
      light: {
        alt: 'Remote caching creates a shared cache for your entire team.',
        src: '/images/docs/remote-caching-light.png',
        props: {
          width: 896,
          height: 489
        }
      }
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 可以与远程缓存进行安全通信 - 一个云服务器，用于存储你的任务结果。这可以避免整个组织中的重复工作，从而节省大量时间。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo can securely communicate with a remote cache - a cloud server that stores the results of your tasks. This can save enormous amounts of time by ", _jsx(_components.strong, {
        children: "preventing duplicated work across your entire organization"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["远程缓存是免费的，可以与 ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/remote-caching#managed-remote-cache-with-vercel",
        children: "托管提供程序"
      }), " 一起使用，也可以作为 ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/remote-caching#self-hosting",
        children: "自托管缓存"
      }), " 使用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Remote Caching is free and can be used with both ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/remote-caching#managed-remote-cache-with-vercel",
        children: "managed providers"
      }), " or as a ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/remote-caching#self-hosting",
        children: "self-hosted cache"
      }), "."]
    }), "\n", _jsxs(Callout, {
      children: [_jsxs(_components.p, {
        children: ["远程缓存是 Turborepo 的一项强大功能，但功能强大，责任重大。首先确保缓存正确，并仔细检查 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/using-environment-variables",
          children: "环境处理变量"
        }), "。另请记住，Turborepo 将日志视为工件，因此请注意打印到控制台的内容。"]
      }), _jsxs(_components.p, {
        children: ["¥Remote Caching is a powerful feature of Turborepo, but, with great power,\ncomes great responsibility. Make sure you are caching correctly first and\ndouble check ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/using-environment-variables",
          children: "handling of environment\nvariables"
        }), ". Please\nalso remember Turborepo treats logs as artifacts, so be aware of what you are\nprinting to the console."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "vercel-vercel",
      children: "Vercel "
    }), "\n", _jsxs(_components.p, {
      children: ["即使你的应用不在 Vercel 上托管，", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel 远程缓存"
      }), " 在所有计划中均可免费使用。按照以下步骤为你的仓库启用远程缓存。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel Remote Cache"
      }), " is free to use on all plans, even if you do not host your applications on Vercel. Follow the steps below to enable Remote Caching for your repository."]
    }), "\n", _jsx(_components.h3, {
      id: "用于本地开发-for-local-development",
      children: "用于本地开发 "
    }), "\n", _jsx(_components.p, {
      children: "¥For Local Development"
    }), "\n", _jsx(_components.p, {
      children: "要将本地 Turborepo 链接到远程缓存，请使用你的 Vercel 账户验证 Turborepo CLI："
    }), "\n", _jsx(_components.p, {
      children: "¥To link your local Turborepo to your Remote Cache, authenticate the Turborepo CLI with your Vercel account:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["如果你尚未安装 ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: ["全局 ", _jsx(_components.code, {
          children: "turbo"
        })]
      }), "，也可以使用包管理器："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can also use your package manager if you do not have ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: ["global ", _jsx(_components.code, {
          children: "turbo"
        })]
      }), " installed:"]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " login"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " login"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " login"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " login"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(Callout, {
      children: [_jsxs(_components.p, {
        children: ["如果你的远程缓存配置为使用单点登录，则需要运行 ", _jsx(_components.code, {
          children: "npx turbo login --sso-team=team-name"
        }), " 才能获取具有正确权限的缓存令牌。"]
      }), _jsxs(_components.p, {
        children: ["¥If your Remote Cache is configured to use single-sign-on you will need to run\n", _jsx(_components.code, {
          children: "npx turbo login --sso-team=team-name"
        }), " in order to get a cache token with the\ncorrect privileges."]
      })]
    }), "\n", _jsx(_components.p, {
      children: "现在，将你的 Turborepo 链接到你的远程缓存："
    }), "\n", _jsx(_components.p, {
      children: "¥Now, link your Turborepo to your Remote Cache:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " link"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["启用后，对当前缓存的包进行一些更改，并使用 ", _jsx(_components.code, {
        children: "turbo run"
      }), " 针对其运行任务。你的缓存工件现在将存储在本地和远程缓存中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Once enabled, make some changes to a package you are currently caching and run tasks against it with ", _jsx(_components.code, {
        children: "turbo run"
      }), ".\nYour cache artifacts will now be stored locally ", _jsx(_components.em, {
        children: "and"
      }), " in your Remote Cache."]
    }), "\n", _jsx(_components.p, {
      children: "要验证，请使用以下命令删除本地 Turborepo 缓存："
    }), "\n", _jsx(_components.p, {
      children: "¥To verify, delete your local Turborepo cache with:"
    }), "\n", _jsxs(Tabs, {
      groupId: "platform-tabs",
      items: ['UNIX', 'Windows'],
      persist: true,
      children: [_jsx(Tab, {
        value: "UNIX",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "rm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -rf"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " ./.turbo/cache"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "Windows",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "rd"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " /s"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " /q"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"./.turbo/cache\""
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["然后，再次运行相同的构建。如果一切正常，", _jsx(_components.code, {
        children: "turbo"
      }), " 不应在本地执行任务。相反，它会从你的远程缓存下载日志和工件，并将它们重放给你。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Then, run the same build again. If things are working properly, ", _jsx(_components.code, {
        children: "turbo"
      }), " should not execute tasks locally. Instead, it will download the logs and artifacts from your Remote Cache and replay them back to you."]
    }), "\n", _jsx(_components.h3, {
      id: "vercel-上的远程缓存-remote-caching-on-vercel",
      children: "Vercel 上的远程缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Remote Caching on Vercel"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你在 Vercel 上构建和托管应用，则一旦你使用 ", _jsx(_components.code, {
        children: "turbo"
      }), "，远程缓存将自动为你设置。更多信息请参阅 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/concepts/monorepos/remote-caching?utm_source=turborepo.com&utm_medium=referral&utm_campaign=docs-link",
        children: "Vercel 文档"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you are building and hosting your apps on Vercel, Remote Caching will be automatically set up on your behalf once you use ", _jsx(_components.code, {
        children: "turbo"
      }), ". Refer to the ", _jsx(_components.a, {
        href: "https://vercel.com/docs/concepts/monorepos/remote-caching?utm_source=turborepo.com&utm_medium=referral&utm_campaign=docs-link",
        children: "Vercel documentation"
      }), " for more information."]
    }), "\n", _jsx(_components.h3, {
      id: "工件完整性和真实性验证-artifact-integrity-and-authenticity-verification",
      children: "工件完整性和真实性验证 "
    }), "\n", _jsx(_components.p, {
      children: "¥Artifact Integrity and Authenticity Verification"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 可以在将工件上传到远程缓存之前使用密钥对其进行签名。Turborepo 使用你提供的密钥对工件进行 ", _jsx(_components.code, {
        children: "HMAC-SHA256"
      }), " 签名。Turborepo 将验证已下载的远程缓存工件。任何验证失败的工件都将被 Turborepo 忽略并视为缓存未命中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo can sign artifacts with a secret key before uploading them to the Remote Cache. Turborepo uses ", _jsx(_components.code, {
        children: "HMAC-SHA256"
      }), " signatures on artifacts using a secret key you provide.\nTurborepo will verify the Remote Cache artifacts' integrity and authenticity when they're downloaded.\nAny artifacts that fail to verify will be ignored and treated as a cache miss by Turborepo."]
    }), "\n", _jsxs(_components.p, {
      children: ["要启用此功能，请在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 配置中将 ", _jsx(_components.code, {
        children: "remoteCache"
      }), " 选项设置为包含 ", _jsx(_components.code, {
        children: "signature: true"
      }), "。然后通过声明 ", _jsx(_components.code, {
        children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
      }), " 环境变量来指定你的密钥。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To enable this feature, set the ", _jsx(_components.code, {
        children: "remoteCache"
      }), " options on your ", _jsx(_components.code, {
        children: "turbo.json"
      }), " config to include ", _jsx(_components.code, {
        children: "signature: true"
      }), ". Then specify your secret key by declaring the ", _jsx(_components.code, {
        children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
      }), " environment variable."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"remoteCache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"signature\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "远程缓存-api-remote-cache-api",
      children: "远程缓存 API "
    }), "\n", _jsx(_components.p, {
      children: "¥Remote Cache API"
    }), "\n", _jsx(_components.p, {
      children: "任何符合 Turborepo 远程缓存 API 规范的 HTTP 服务器都可以实现远程缓存。"
    }), "\n", _jsx(_components.p, {
      children: "¥A Remote Cache can be implemented by any HTTP server that meets Turborepo's Remote Caching API specification."
    }), "\n", _jsx(_components.h3, {
      id: "使用-vercel-管理远程缓存-managed-remote-cache-with-vercel",
      children: "使用 Vercel 管理远程缓存 "
    }), "\n", _jsx(_components.p, {
      children: "¥Managed Remote Cache with Vercel"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com",
        children: "Vercel"
      }), "，Turborepo 的创建者和维护者，提供与 Turborepo 完全兼容的托管远程缓存。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "https://vercel.com",
        children: "Vercel"
      }), ", the creators and maintainers of Turborepo, provide a managed Remote Cache that is fully compatible with Turborepo."]
    }), "\n", _jsxs(_components.p, {
      children: ["使用 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel 远程缓存"
      }), " 无需配置，并通过开源 ", _jsx(_components.a, {
        href: "https://github.com/vercel/remote-cache",
        children: "Vercel 远程缓存 SDK"
      }), " 自动与 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/deployments/overview",
        children: "Vercel 部署"
      }), " 集成。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel Remote Cache"
      }), " is zero-configuration and automatically integrates with ", _jsx(_components.a, {
        href: "https://vercel.com/docs/deployments/overview",
        children: "Vercel deployments"
      }), " through the open-source ", _jsx(_components.a, {
        href: "https://github.com/vercel/remote-cache",
        children: "Vercel Remote Cache SDK"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["了解有关 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/turborepo",
        children: "Vercel 上的 Turborepo"
      }), " 或 ", _jsx(_components.a, {
        href: "https://vercel.com/templates?search=turborepo",
        children: "免费部署模板"
      }), " 的更多信息以试用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Learn more about ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/turborepo",
        children: "Turborepo on Vercel"
      }), " or ", _jsx(_components.a, {
        href: "https://vercel.com/templates?search=turborepo",
        children: "deploy a template for free"
      }), " to try it out."]
    }), "\n", _jsx(_components.h3, {
      id: "自托管-self-hosting",
      children: "自托管 "
    }), "\n", _jsx(_components.p, {
      children: "¥Self-hosting"
    }), "\n", _jsxs(_components.p, {
      children: ["你还可以自行托管自己的远程缓存，并使用 ", _jsx(_components.code, {
        children: "--manual"
      }), " 标志登录，提供 API URL、团队和令牌信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can also self-host your own Remote Cache and log into it using the ", _jsx(_components.code, {
        children: "--manual"
      }), " flag to provide API URL, team, and token information."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --manual"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h4, {
      id: "openapi-规范-openapi-specification",
      children: "OpenAPI 规范 "
    }), "\n", _jsx(_components.p, {
      children: "¥OpenAPI specification"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/openapi",
            children: "易于阅读的查看器"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/openapi",
            children: "Human-readable viewer"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/api/remote-cache-spec",
            children: "JSON"
          })
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["目前，所有版本的 ", _jsx(_components.code, {
        children: "turbo"
      }), " 都与 ", _jsx(_components.code, {
        children: "v8"
      }), " 端点兼容。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥At this time, all versions of ", _jsx(_components.code, {
        children: "turbo"
      }), " are compatible with the ", _jsx(_components.code, {
        children: "v8"
      }), " endpoints."]
    }), "\n", _jsx(_components.h4, {
      id: "社区实现-community-implementations",
      children: "社区实现 "
    }), "\n", _jsx(_components.p, {
      children: "¥Community implementations"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 社区已经创建了远程缓存的开源实现。"
    }), "\n", _jsx(_components.p, {
      children: "¥The Turborepo community has created open-source implementations of the Remote Cache."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "https://github.com/brunojppb/turbo-cache-server",
            children: _jsx(_components.code, {
              children: "brunojppb/turbo-cache-server"
            })
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "https://github.com/ducktors/turborepo-remote-cache",
            children: _jsx(_components.code, {
              children: "ducktors/turborepo-remote-cache"
            })
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "https://github.com/Tapico/tapico-turborepo-remote-cache",
            children: _jsx(_components.code, {
              children: "Tapico/tapico-turborepo-remote-cache"
            })
          })
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
